import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const InfoPanel = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  overflow: hidden;
`;

const PanelHeader = styled.div`
  padding: 20px 25px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  align-items: center;
  gap: 10px;
  
  h3 {
    font-size: 1.2em;
    color: #2c3e50;
    margin: 0;
  }
  
  i {
    color: #667eea;
  }
`;

const PanelContent = styled.div`
  padding: 25px;
`;

const InfoItem = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e9ecef;
  
  &:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: none;
  }
`;

const InfoIcon = styled.div`
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.1em;
`;

const InfoContent = styled.div`
  flex: 1;
`;

const InfoLabel = styled.div`
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 5px;
`;

const InfoValue = styled.div`
  color: #7f8c8d;
  font-size: 0.9em;
  word-break: break-all;
`;

const StatusIndicator = styled.span`
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 8px;
  background-color: ${props => props.isActive ? '#27ae60' : '#e74c3c'};
`;

const Loading = styled.div`
  text-align: center;
  padding: 40px;
  color: #7f8c8d;
  
  i {
    font-size: 2em;
    margin-bottom: 15px;
    color: #667eea;
  }
`;

const ErrorMessage = styled.div`
  background: #fee;
  border: 1px solid #fcc;
  color: #e74c3c;
  padding: 20px;
  border-radius: 12px;
  text-align: center;
  margin: 20px 0;
`;

const StreamInfo = () => {
  const [streamData, setStreamData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchStreamInfo();
    const interval = setInterval(fetchStreamInfo, 30000); // Refresh every 30 seconds

    return () => clearInterval(interval);
  }, []);

  const fetchStreamInfo = async () => {
    try {
      setLoading(true);
      const response = await fetch('http://159.198.65.99:3000/api/stream-info?stream=holy_tv_livestream_key', {
        headers: {
          'Authorization': 'Bearer holytv_api_key_2024_secure_streaming_server'
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        setStreamData(data);
        setError(null);
      } else {
        setError('Could not fetch stream information');
      }
    } catch (error) {
      console.error('Error fetching stream info:', error);
      setError('Error: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <InfoPanel>
        <PanelHeader>
          <i className="fas fa-info-circle"></i>
          <h3>Stream Information</h3>
        </PanelHeader>
        <PanelContent>
          <Loading>
            <i className="fas fa-spinner fa-spin"></i>
            <p>Loading stream information...</p>
          </Loading>
        </PanelContent>
      </InfoPanel>
    );
  }

  if (error) {
    return (
      <InfoPanel>
        <PanelHeader>
          <i className="fas fa-info-circle"></i>
          <h3>Stream Information</h3>
        </PanelHeader>
        <PanelContent>
          <ErrorMessage>
            <i className="fas fa-exclamation-triangle"></i>
            <p>{error}</p>
          </ErrorMessage>
        </PanelContent>
      </InfoPanel>
    );
  }

  return (
    <InfoPanel>
      <PanelHeader>
        <i className="fas fa-info-circle"></i>
        <h3>Stream Information</h3>
      </PanelHeader>
      <PanelContent>
        <InfoItem>
          <InfoIcon>
            <i className="fas fa-broadcast-tower"></i>
          </InfoIcon>
          <InfoContent>
            <InfoLabel>Status</InfoLabel>
            <InfoValue>
              <StatusIndicator isActive={streamData?.isActive} />
              {streamData?.isActive ? 'LIVE' : 'OFFLINE'}
            </InfoValue>
          </InfoContent>
        </InfoItem>
        
        <InfoItem>
          <InfoIcon>
            <i className="fas fa-tag"></i>
          </InfoIcon>
          <InfoContent>
            <InfoLabel>Stream Name</InfoLabel>
            <InfoValue>{streamData?.streamName || 'Holy TV Live Stream'}</InfoValue>
          </InfoContent>
        </InfoItem>
        
        <InfoItem>
          <InfoIcon>
            <i className="fas fa-key"></i>
          </InfoIcon>
          <InfoContent>
            <InfoLabel>Stream Key</InfoLabel>
            <InfoValue>{streamData?.streamKey || 'holy_tv_livestream_key'}</InfoValue>
          </InfoContent>
        </InfoItem>
        
        <InfoItem>
          <InfoIcon>
            <i className="fas fa-video"></i>
          </InfoIcon>
          <InfoContent>
            <InfoLabel>RTMP URL</InfoLabel>
            <InfoValue>{streamData?.rtmpUrl || 'rtmp://159.198.65.99:1935/live'}</InfoValue>
          </InfoContent>
        </InfoItem>
        
        <InfoItem>
          <InfoIcon>
            <i className="fas fa-play-circle"></i>
          </InfoIcon>
          <InfoContent>
            <InfoLabel>HLS URL</InfoLabel>
            <InfoValue>{streamData?.playbackUrl || 'http://159.198.65.99:8000/live/holy_tv_livestream_key/index.m3u8'}</InfoValue>
          </InfoContent>
        </InfoItem>
      </PanelContent>
    </InfoPanel>
  );
};

export default StreamInfo; 